
import React from 'react';

const HeroSection: React.FC = () => {
  return (
    <section 
      className="relative min-h-[600px] flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/03b14c72-bcb0-4986-8422-9a0f7b4c2488.jpg')`
      }}
    >
      <div className="container mx-auto px-6 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Industrial Hygiene Services
          </h1>
          <p className="text-xl md:text-2xl mb-8 leading-relaxed">
            Hazard Exposure Assessments & Workplace Safety Solutions
          </p>
          <p className="text-lg mb-10 max-w-3xl mx-auto">
            Our Industrial Hygiene services safeguard worker health by identifying, evaluating, and controlling workplace environmental hazards. We develop customized plans based on detailed assessments and regulatory compliance to ensure a safe working environment.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="#contact-form" 
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              Get Assessment Quote
            </a>
            <a 
              href="#services" 
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg font-semibold transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              View Our Services
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
